
import { IClient } from '@interfaces/client.interface';
import { IMessageApi } from '@interfaces/rmessage-api.interface';
import { createAction, props } from '@ngrx/store';


export enum ClientActionType {
  SearchClients = '[Client Component] Search Client',
  SearchClientsSuccess = '[Client API] Search Client Success',

  UpdateClient = '[Client Component] Update Client',
  UpdateClientSuccess = '[Client API] Update Client Success',
  CreateClient = '[Client Component] Create Client',
  CreateClientSuccess = '[Client API] Create Client Success',


  SetClient = '[Client Component] Set Client in store',
  SetDriver = '[Client Component] Set Driver in store',
  SetMessage = '[Client Component] Set SetMessage in store',
  reset = '[Client Component] re set values',

  ActionFailure = '[Client API] Execute action failure',
  ActionSuccess = '[Client API] Execute action success',
  LoadSuccess = '[Client API] Load Success',
  Refresh = '[Client Page] Refresh',
  Selected = '[Client Page] Select',
  SubmitSuccess = '[Client API] Submit Success'
}

const searchClients = createAction(
  ClientActionType.SearchClients,
);

const searchClientsSuccess = createAction(
  ClientActionType.SearchClientsSuccess,
  props<{ clientList: IClient[] }>()
);

const updateClient = createAction(
  ClientActionType.UpdateClient,
  props<{ client: IClient }>()
);

const updateClientSuccess = createAction(
  ClientActionType.UpdateClientSuccess,
  props<{ client: IClient }>()
);

const createClient = createAction(
  ClientActionType.CreateClient,
  props<{ client: IClient }>()
);
const createClientSuccess = createAction(
  ClientActionType.CreateClientSuccess,
  props<{ client: IClient }>()
);

const setClient = createAction(
  ClientActionType.SetClient,
  props<{ client: IClient }>()
);

const setDriver = createAction(
  ClientActionType.SetDriver,
  props<{ client: IClient }>()
);

const getErrors = createAction(
  ClientActionType.ActionFailure,
  props<{ error: any }>()
);
const setMessage = createAction(
  ClientActionType.SetMessage,
  props<{ message: IMessageApi }>()
);

const reset = createAction(
  ClientActionType.reset
);

export const ClientActions = {
  searchClients,
  searchClientsSuccess,
  updateClient,
  updateClientSuccess,
  createClient,
  createClientSuccess,
  setClient,
  setDriver,
  getErrors,
  setMessage,
  reset
}

